var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CreateReportDialogService } from './create-report-service.interface';
let CreateReportCommandContribution = class CreateReportCommandContribution {
    constructor(_createReportDialogService) {
        this._createReportDialogService = _createReportDialogService;
    }
    registerCommands(commandRegistry) {
        commandRegistry.registerCommand({
            id: 'open-create-report',
        }, {
            execute: () => {
                return this._createReportDialogService.open();
            },
        });
        commandRegistry.registerCommand({
            id: 'close-create-report',
        }, {
            execute: () => {
                return this._createReportDialogService.close();
            },
        });
    }
};
CreateReportCommandContribution = __decorate([
    injectable(),
    __param(0, inject(CreateReportDialogService)),
    __metadata("design:paramtypes", [typeof (_a = typeof CreateReportDialogService !== "undefined" && CreateReportDialogService) === "function" ? _a : Object])
], CreateReportCommandContribution);
export { CreateReportCommandContribution };
